<!-- NAVBAR-->
<nav class="navbar navbar-expand-lg py-3 fixed-top" style="z-index: -1;">
  <div class="container_head">
    <a href="#" class="navbar-brand" style="width: 100%;">
      <!-- Logo Image -->
      <img src="https://www.tamilvu.org/sites/default/files/kanithamizh_logo%20%282%29_64_0.png" alt="முகப்பு"
        width="60px" height="60px">
      <!-- Logo Text -->
      <span class="font-weight-bold" style="padding: 30%;">தமிழ் இலக்கியப் பதிப்பி - Tamil Text Editor</span>
    </a>
  </div>
</nav>